"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var base_portfolio_config_model_1 = require("./base-portfolio-config.model");
var overview_content_field_model_1 = require("./overview-content-field.model");
var overview_field_type_1 = require("./overview-field-type");
var lodash_1 = require("lodash");
/**
 * Model of single category summary card config.
 * Consists of portfolio, overview & some minor configurations.
 */
var OverviewConfigItemModel = /** @class */ (function () {
    function OverviewConfigItemModel(numberOfLevels, numberOfFieldsForLevel, defaultOverviewFieldType) {
        if (numberOfLevels === void 0) { numberOfLevels = 3; }
        if (numberOfFieldsForLevel === void 0) { numberOfFieldsForLevel = 3; }
        this.contentFieldsWithLevels =
            Array.from(Array(numberOfLevels)).map(function () {
                return {
                    hasValue: false,
                    data: Array.from(Array(numberOfFieldsForLevel)).map(function () {
                        return new overview_content_field_model_1.OverviewContentPortfolioFieldModel(defaultOverviewFieldType || overview_field_type_1.OverviewPortfolioFieldType.FIELD, null, null);
                    })
                };
            });
    }
    OverviewConfigItemModel.constructEmptyLevel = function (numberOfFields) {
        var itemsToAdd = Array.from(new Array(numberOfFields));
        return {
            hasValue: false,
            data: itemsToAdd.map(function () { return new overview_content_field_model_1.OverviewContentPortfolioFieldModel(); })
        };
    };
    OverviewConfigItemModel.cloneFromItem = function (itemConfig) {
        var numberOfLevels = itemConfig.contentFieldsWithLevels && itemConfig.contentFieldsWithLevels.length || 0;
        var numberOfFieldsForLevel = itemConfig.contentFieldsWithLevels &&
            itemConfig.contentFieldsWithLevels.length && itemConfig.contentFieldsWithLevels[0].data.length || 0;
        var newItem = new OverviewConfigItemModel(numberOfLevels, numberOfFieldsForLevel);
        newItem.title = itemConfig.title;
        newItem.id = itemConfig.id;
        newItem.itemCategoryName = itemConfig.itemCategoryName;
        newItem.form = itemConfig.form;
        newItem.editForm = itemConfig.editForm;
        newItem.customUrl = itemConfig.customUrl;
        newItem.icon = itemConfig.icon;
        newItem.cardType = itemConfig.cardType;
        newItem.orderId = itemConfig.orderId;
        if (itemConfig.portfolioConfig) {
            newItem.portfolioConfig = new base_portfolio_config_model_1.BasePortfolioConfigModel();
            newItem.portfolioConfig.quickFilterField = itemConfig.portfolioConfig.quickFilterField;
            newItem.portfolioConfig.sortingDirection = itemConfig.portfolioConfig.sortingDirection;
            newItem.portfolioConfig.defaultSortingField = itemConfig.portfolioConfig.defaultSortingField;
            newItem.portfolioConfig.fields = itemConfig.portfolioConfig.fields;
            newItem.portfolioConfig.filterFields = itemConfig.portfolioConfig.filterFields;
        }
        newItem.contentFieldsWithLevels = itemConfig.contentFieldsWithLevels.map(function (items) {
            return {
                hasValue: items.hasValue,
                data: items.data.map(function (item) {
                    return new overview_content_field_model_1.OverviewContentPortfolioFieldModel(item.overviewPortfolioFieldType, item.fieldName, item.aggregateConfig);
                })
            };
        });
        return newItem;
    };
    OverviewConfigItemModel.prototype.resizeContentFieldsWithLevels = function (numberOfLevels, numberOfFieldsForLevel, overviewFieldType) {
        var _this = this;
        if (this.contentFieldsWithLevels.length === numberOfLevels &&
            this.contentFieldsWithLevels[0].data.length === numberOfFieldsForLevel) {
            return;
        }
        if (this.contentFieldsWithLevels[0].data.length > numberOfFieldsForLevel) {
            var numberOfItemsToDelete_1 = this.contentFieldsWithLevels[0].data.length - numberOfFieldsForLevel;
            this.contentFieldsWithLevels.forEach(function (levelFields) {
                return levelFields.data.splice(numberOfFieldsForLevel, numberOfItemsToDelete_1);
            });
        }
        else {
            var itemsToAdd_1 = Array.from(Array(numberOfFieldsForLevel - this.contentFieldsWithLevels[0].data.length));
            this.contentFieldsWithLevels.forEach(function (levelFields) {
                return itemsToAdd_1.forEach(function () { return levelFields.data.push(new overview_content_field_model_1.OverviewContentPortfolioFieldModel(overviewFieldType)); });
            });
        }
        if (this.contentFieldsWithLevels.length > numberOfLevels) {
            var numberOfLevelsToDelete = this.contentFieldsWithLevels.length - numberOfLevels;
            this.contentFieldsWithLevels.splice(numberOfLevels, numberOfLevelsToDelete);
        }
        else {
            var levelsToAdd = Array.from(Array(numberOfLevels - this.contentFieldsWithLevels.length));
            levelsToAdd.forEach(function () {
                return _this.contentFieldsWithLevels.push(OverviewConfigItemModel.constructEmptyLevel(numberOfFieldsForLevel));
            });
        }
    };
    OverviewConfigItemModel.prototype.clone = function () {
        return lodash_1.cloneDeep(this);
    };
    return OverviewConfigItemModel;
}());
exports.OverviewConfigItemModel = OverviewConfigItemModel;
//# sourceMappingURL=overview-config-item.model.js.map